import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import SectionAccordion from './SectionAccordion';

const propTypes = {
  fields: PropTypes.object,
  paneId: PropTypes.string,
  setActionType: PropTypes.func,
  setOpenSectionBuilder: PropTypes.func,
  setSectionInitValues: PropTypes.func,
};

function SectionsArray({
  fields,
  paneId,
  setActionType,
  setOpenSectionBuilder,
  setSectionInitValues,
}) {
  const onSectionEdit = (sectionValue) => {
    setActionType('edit');
    setOpenSectionBuilder(true);
    setSectionInitValues(sectionValue);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    fields.move(result.source.index, result.destination.index);
  };

  const renderSectionsArray = () => {
    return (
      <>
        {fields.map((name, index) => {
          const isDragDisabled = fields.length < 2;
          return (
            <Draggable
              key={name}
              draggableId={name}
              index={index}
              // disableInteractiveElementBlocking={false}
              isDragDisabled={isDragDisabled}
            >
              {(draggableProvided, snapshot) => (
                <SectionAccordion
                  draggableProvided={draggableProvided}
                  snapshot={snapshot}
                  fields={fields}
                  fieldName={name}
                  fieldIndex={index}
                  paneId={paneId}
                  onSectionEdit={onSectionEdit}
                />
              )}
            </Draggable>
          );
        })}
      </>
    );
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sections-array-droppable">
        {(droppableProvided) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
          >
            {renderSectionsArray()}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

SectionsArray.propTypes = propTypes;

export default SectionsArray;
